import { Card, Input, CardBody, Button, CardFooter, useSelect, SelectItem, Select } from "@heroui/react"
import { useEffect, useRef, useState } from "react"
import { ErrorCard, MainContainer } from "../../components"
import { useSelector } from "react-redux"
import { toast } from "react-toastify"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons"
import { useFetchWithBody, usePost, usePostMutateWithSuccess } from "../../api/reactQueryCustomHooks"
import { apiRoute, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, getModMandatory } from "../../constants/enum"
import { useModalToast } from "../../components/modalToast/ModalToastContext"

const LotCodeUpdate = () => {
    const { user } = useSelector((state) => state.auth)
    const { compCode } = useSelector((state) => state.company)
    const [updateCodeType, setUpdateCodeType] = useState(null)
    const [diamondType, setDiamondType] = useState("P")
    const [msg, setMsg] = useState("")
    const [isUseMfgNoAsMktno, setIsUseMfgNoAsMktno] = useState(true)
    const submitLockRef = useRef(false);//
    const { show } = useModalToast();

    let [formData, setFormData] = useState({
        lotNo: "",
        pktNo: "",
        newLotNo: "",
        newPktNo: "",
        newSLotNo: "",
        newSPktNo: ""
    })
    const handleChange = (e) => {
        const { value, name } = e.target;

        setFormData({ ...formData, [name]: value })


    }
    const hnadleCheckLotPktNos = (chkNewNo, name, value) => {
        setMsg("")
        let t_lotno = name == "lotNo" ? value : formData.lotNo
        let t_pktno = name == "pktNo" ? value : formData.pktNo
        if (chkNewNo) {
            t_lotno = name == "newLotNo" ? value : formData.newLotNo
            t_pktno = name == "newPktNo" ? value : formData.newPktNo
        }
        const mklcode = updateCodeType == "mfgno" ? 1 : 0
        if (t_lotno != "" && t_pktno != "") {
            funChkPktLotNo({
                data: {
                    compcode: compCode.join(","),
                    lotno: t_lotno,
                    pktno: t_pktno,
                    mktlcode: mklcode
                },
                onSuccess: (data) => {
                    if (data && data.length > 0) {
                        if (chkNewNo) {
                            if (data[0].count > 0) {

                                setMsg(`New ${updateCodeType == "mfgno" ? "Mfg." : ""} Lot No.(${formData.newLotNo})  & Pkt No.(${formData.newPktNo}) already exists`)
                                //if (!toast.isActive("lotnewtoast")) {
                                    show(`Duplicate  New ${updateCodeType == "mfgno" ? "Mfg." : ""} Lot No / Pkt No Not Allow`)
                                    //  {
                                    //     "position": "top-center",
                                    //     className: "toast-error",
                                    //     toastId: "lotnewtoast"
                                    // })
                                    setFormData({ ...formData, newLotNo: "", newPktNo: "" })
                                //}
                            }
                        }
                        else {
                            if (data[0].count <= 0) {
                               // if (!toast.isActive("lottoast")) {
                                    show(` ${updateCodeType == "mfgno" ? "Mfg." : ""} Lot No / Pkt No Not Found`)
                                    // , {
                                    //     "position": "top-center",
                                    //     className: "toast-error",
                                    //     toastId: "lottoast"
                                   // })
                                    setFormData({ ...formData, lotNo: "", pktNo: "" })
                               // }
                            }
                        }
                    }
                }
            })
        }
    }
    const handleBlur = (e) => {
        const { value, name } = e.target;

        if (name == "lotNo" || name == "pktNo") {
            hnadleCheckLotPktNos(false, name, value)
        }
        else if (name == "newLotNo" || name == "newPktNo") {
            hnadleCheckLotPktNos(true, name, value)
        }
    }

    const handleReset = () => {
        setUpdateCodeType(isUseMfgNoAsMktno ? "mktno" : "mfgno")
        setMsg("")
        setDiamondType("P")
        setFormData({
            lotNo: "",
            pktNo: "",
            newLotNo: "",
            newPktNo: "",
            newSLotNo: "",
            newSPktNo: "",
        })

    }
    const { data: modSetting = [], } = useFetchWithBody({
        url: apiRoute.modSetting.getModSetting,
        queryKey: "fetchModSettingInwardItem",
        inputData: {
            mod_name: ENUM_MOD_NAME.GeneralSettings,
        }
    })
    useEffect(() => {
        if (modSetting && modSetting.length > 0) {
            const mktSetting = getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.UseMfgNoAsMktNo, modSetting);
            setIsUseMfgNoAsMktno(mktSetting)
            if (mktSetting)
                setUpdateCodeType("mktno")
            else
                setUpdateCodeType("mfgno")
        }

    }, [modSetting])
    const { data: dupLotPktNo = [], mutate: funChkPktLotNo } = usePostMutateWithSuccess({
        url: apiRoute.memoEntry.checkLotPktNo,
        queryKey: "checkLotNoPktData",

    })
    const { isPending, isError, mutate: funUpdateCode } = usePost({
        url: apiRoute.stockEntry.updateLotCode,
        queryKey: "Updatelotcode",
        onSuccessTasks: (data) => {
            submitLockRef.current = false;
            toast.success("Lot No &  PktNo  Updated", {
                "position": "top-center"
            })
            handleReset()
        },
        // resetValues

    })
    if (isError) {
        return <ErrorCard />
    }
    const funSubmit = () => {
        const New_data = {
            lotNo: formData.lotNo,
            pktNo: formData.pktNo,
            newLotNo: isUseMfgNoAsMktno ? formData.newLotNo : updateCodeType == 'mktno' ? formData.newLotNo : null,
            newPktNo: isUseMfgNoAsMktno ? formData.newPktNo : updateCodeType == 'mktno' ? formData.newPktNo : null,
            newSLotNo: isUseMfgNoAsMktno ? formData.newLotNo : updateCodeType == 'mfgno' ? formData.newLotNo : null,
            newSPktNo: isUseMfgNoAsMktno ? formData.newPktNo : updateCodeType == 'mfgno' ? formData.newPktNo : null,

        }
        
 console.log(New_data)
        funUpdateCode({
            data: {
                comp_code: compCode.join(","),
                trade_of: diamondType,
                form_data: New_data,
                is_mfgno: isUseMfgNoAsMktno ? 0 : updateCodeType == "mfgno" ? 1 : 0,
                user_id: user.username
            }
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setMsg("")

        if ((!formData.newLotNo || formData.newLotNo == null || formData.newLotNo.trim() == "") && (!formData.newPktNo || formData.newPktNo == null || formData.newPktNo.trim() == "")) {
            show("New Lot No & PktNo both should not be empty, One must have value")
        //    , {
        //         "position": "top-center",
        //         className: "toast-error"
        //     })
            return;
        }
        if (submitLockRef.current) return;
        submitLockRef.current = true;
        //if (formData.newLotNo.trim() == "" || formData.newPktNo.trim() == '') {
        const t_lotno = formData?.newLotNo.trim() == "" ? formData?.lotNo : formData?.newLotNo
        const t_pktno = formData?.newPktNo.trim() == "" ? formData?.pktNo : formData?.newPktNo
        const mklcode = updateCodeType == "mfgno" ? 1 : 0

        funChkPktLotNo({
            data: {
                compcode: compCode.join(","),
                lotno: t_lotno,
                pktno: t_pktno,
                mktlcode: mklcode
            },
            onSuccess: (data) => {
                
                if (!submitLockRef.current) return; // 🚫 ignore stale calls
                if (data[0].count > 0) {
                    //if (!toast.isActive("lotgnewtoast")) {
                    const msg = formData.newPktNo == "" ? `This Lot No.(${formData.newLotNo}) already assigned Pkt No.(${formData.pktNo})` :
                        formData.newLotNo == "" ? `This Pkt No.(${formData.newPktNo}) already assigned To Lot No.(${formData.lotNo})` : ""
                    setMsg(msg)
                    setFormData({ ...formData, newLotNo: "", newPktNo: "" })
                    show(`Duplicate New ${updateCodeType == "mfgno" ? "Mfg." : ""} Lot No. / Packet No Not Allow`)
                    // , {
                    //     "position": "top-center",
                    //     className: "toast-error",
                    //     toastId: "lotgnewtoast"
                    // })
                    submitLockRef.current = false;
                    return;
                    //}

                }
                else {
                    setMsg("")
                    funSubmit()
                }

            }
        })
        // }
        // else {
        //     funSubmit()
        // }

      
        // })

    }
    return (
        <div>
            <MainContainer pageName="Update Lot Code / Packet No." breadcrumbs={["Stock", "Update Lot Code / Packet No."]}>

                {/* <h2 className="mb-4 text-center font-bold leading-none tracking-tight
                 text-gray-900 md:text-1xl lg:text-xl dark:text-white" >Reset Password</h2> */}
                <div className=" shadow pb-5  min-w-md">
                    <div className="  pb-5 flex flex-col px-5 item-center">
                        <form onSubmit={handleSubmit}>
                            {isUseMfgNoAsMktno ? "" :
                                <Select
                                    size="sm"
                                    name={"updateBy"}
                                    className="mb-5"
                                    classNames={{
                                        label: " font-semibold text-md",
                                    }}
                                    isMultiline={true}
                                    isRequired
                                    placeholder=""
                                    label="Update Code Type"
                                    selectedKeys={[updateCodeType]}

                                    selectionMode="single"
                                    onChange={(e) => setUpdateCodeType(e.target.value)}
                                    variant="flat"
                                    color="danger"
                                >

                                    <SelectItem
                                        key={"mktno"}
                                    >
                                        Marketing No.
                                    </SelectItem>
                                    <SelectItem
                                        key={"mfgno"}
                                    >
                                        Manufacturing No.
                                    </SelectItem>

                                </Select>
                            }
                            <Select
                                size="sm"
                                name={"diamondType"}
                                className="mb-5"
                                classNames={{
                                    label: " font-semibold text-md",
                                }}
                                isMultiline={true}
                                isRequired
                                placeholder=""
                                label="Diamond Type"
                                selectedKeys={[diamondType]}
                                selectionMode="single"
                                onChange={(e) => setDiamondType(e.target.value)}
                                variant="flat"
                                color="warning"
                            >

                                <SelectItem key={"P"} >
                                    Polish
                                </SelectItem>
                                <SelectItem key={"R"} >
                                    Rough
                                </SelectItem>

                            </Select>
                            <div className="items-center flex gap-2 mb-5">
                                <Input
                                    isRequired
                                    label={updateCodeType == "mfgno" ? "Mfg. Lot No" : "Lot No"}
                                    placeholder=" "
                                    size="md"
                                    labelPlacement="outside"
                                    name="lotNo"
                                    className="  "
                                    classNames={{ "label": "text-xs font-bold" }}
                                    variant="bordered"
                                    value={formData.lotNo}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    type={"text"}

                                />
                                <Input
                                    isRequired
                                    label={updateCodeType == "mfgno" ? "Mfg. Packet No." : "Packet No"}
                                    placeholder=" "
                                    size="md"
                                    labelPlacement="outside"
                                    name="pktNo"
                                    className=" font-semibold"
                                    variant="bordered"
                                    classNames={{ "label": "text-xs font-bold" }}
                                    value={formData.pktNo}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    type={"text"}

                                />
                            </div>
                            <div className="items-center flex gap-2 mb-2">
                                <Input
                                    // isRequired
                                    label={updateCodeType == "mfgno" ? "New Mfg. Lot No" : "New Lot No"}
                                    placeholder=" "
                                    size="md"
                                    labelPlacement="outside"
                                    name="newLotNo"
                                    className=" font-semibold"
                                    variant="bordered"
                                    classNames={{ "label": "text-xs font-bold" }}
                                    value={formData.newLotNo}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    type={"text"}

                                />
                                <Input
                                    //isRequired
                                    label={updateCodeType == "mfgno" ? "New Mfg. Packet No" : "New Packet No"}
                                    placeholder=" "
                                    size="md"
                                    labelPlacement="outside"
                                    name="newPktNo"
                                    className=" font-semibold"
                                    variant="bordered"
                                    value={formData.newPktNo}
                                    classNames={{ "label": "text-xs font-bold" }}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    type={"text"}

                                />

                            </div>

                            <h2 className="p-2 text-red-500" >{msg}</h2>

                            <div className="flex gap-5  mt-5 justify-center">
                                <Button color="primary" className="font-semibold uppercase bg-slate-700 text-white" type="submit" size="sm" isLoading={isPending} >
                                    Update Code
                                </Button>
                                <Button color="danger" className="font-semibold uppercase " type="submit" size="sm" onPress={handleReset} >
                                    Clear Values
                                </Button>
                            </div>


                        </form>


                    </div>
                </div>
            </MainContainer>
        </div>
    )
}
export default LotCodeUpdate